/**
 * @returns {boolean}
 */
function detectEdgeIE() {
  // adapted from https://codepen.io/gapcode/pen/vEJNZN
  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

let IEEdge;

let IE;

/**
 * Returns true if the browser is MS Edge or IE.
 *
 * @export
 * @return {boolean}
 */
export default function isEdgeIE() {
  if (IEEdge === undefined) {
    IEEdge = detectEdgeIE();
  }
  return IEEdge;
}

export function isIE() {
  if (IE === undefined) {
    IE = (detectEdgeIE() <= 11 && detectEdgeIE() > 0);
  }
  return IE;
}



// WEBPACK FOOTER //
// ./src/helpers/detectEdgeIE.js